import { render, staticRenderFns } from "./LogoV6Icon.vue?vue&type=template&id=3fe8e616&"
import script from "./LogoV6Icon.vue?vue&type=script&lang=js&"
export * from "./LogoV6Icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports